// Imports
import { useStateValue } from '../../_global/jsx/store';
import { dangerousHTML, sendXHR, failedRequest } from 'src/lib/utils.js';


// Binds

// Stateful components

export const ReactColourKey = () => {

    const [{ globalText }, dispatch] = useStateValue();

    return (
        <div className="br-app-box">
            <p><strong>{globalText.colourKeyTitle}</strong></p>
            <div dangerouslySetInnerHTML={dangerousHTML(globalText.colourKeyContent)}></div>
            <ul className="br-app-key">
                <li  className="br-app-key__item br-app-key__item--weakness">
                    <span className="br-app-key__badge"></span>
                    <span className="br-app-key__text">{globalText.colourKeyLabelWeakness}</span>
                </li>
                <li className="br-app-key__item br-app-key__item--improvement">
                    <span className="br-app-key__badge"></span>
                    <span className="br-app-key__text">{globalText.colourKeyLabelImprovement}</span>
                </li>
                <li className="br-app-key__item br-app-key__item--strength">
                    <span className="br-app-key__badge"></span>
                    <span className="br-app-key__text">{globalText.colourKeyLabelStrength}</span>
                </li>
            </ul>
        </div>
    );
};
